import { Organization } from '../../pages/organisation/OrganizationForm';
import { PaginationProp } from '../../utils/globalInterface/GlobalInterfaces';
import api from './index';
const getSearchData = (data: string) =>
  api.post('/organization/find', { query: data });
const getOrganizationName = () => api.get('/organization/name');
const getOrganisation = (id: string) => api.get(`/organization/${id}`);
const getOrganisations = (data: PaginationProp) =>
  api.post('/organization/getRows', data);
const addOrganisation = (data: Organization) => api.post('/organization', data);
const addOrganisationSignUp = (data: Organization) =>
  api.post('/organization/signup', data);
const editOrganisation = (data: Organization) =>
  api.put(`/organization/${data.id}`, data);
const deleteOrganisation = (
  id: string //@ts-ignore
) => api.delete(`/organization/${id}`);
// Send only the fields this endpoint validates. The grid row may also carry
// raw table columns (import_run_id, approved) picked up from a delete/update
// response, and posting those back is rejected as unknown keys.
const restoreOrganisation = (data: any) =>
  api.put(`/organization/status`, {
    id: data.id,
    name: data.name,
    city: data.city,
    state: data.state ?? null,
    country: data.country,
    timezone: data.timezone,
    sector: data.sector,
    type: data.type,
  });
const getDemogByOrg = (org: { id: string | undefined }) =>
  api.get('/organization/org-demog', { params: { org: org } });
const updateExportPermission = (status: any, id: any) =>
  api.put(`/organization/permission-anonymous-export`, { status, id });

export {
  addOrganisationSignUp,
  addOrganisation,
  getOrganisations,
  getOrganisation,
  getOrganizationName,
  editOrganisation,
  deleteOrganisation,
  getSearchData,
  restoreOrganisation,
  getDemogByOrg,
  updateExportPermission,
};
